import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import list from './list';

// const TradeHistory = ({match}) => (
//   <div className="dashboard-wrapper">
//     <Switch>
//       <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
//       <Redirect exact from={`${match.url}/list`} to={`${match.url}/list/all`}/>
//       <Route path={`${match.url}/list/:group`} component={list}/>
//       <Redirect to="/error"/>
//     </Switch>
//   </div>
// );

const TradeHistory = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
      <Route path={`${match.url}/list`} component={list}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default TradeHistory;

